import React from 'react';
import Select from 'react-select';
import localize from '../localize';
import './Select.css';

export default localize('forms.select')(({ i18n, ...props }) => (
  <Select placeholder={i18n.t('placeholder')} searchable={false} autoBlur={true} {...props} />
));



// WEBPACK FOOTER //
// ./src/components/Select/index.js